export const CALCOM = {
  discovery: "natalialifecoach/discoverycall",
  session: "natalialifecoach/coachingsession",
};

export const EMAIL = "info@natalialifecoach.com";
export const PAYPAL_ME_URL = "https://www.paypal.com/paypalme/natalialifecoach";
export const EMAIL_MAILTO =
  "mailto:info@natalialifecoach.com?subject=Free%20Consultation&body=Please%20include%20the%20following%20in%20the%20body%20of%20this%20email%3A%0A1.%20Full%20Name%20%0A2.%20Phone%20Number%0A3.%20Availability%20for%20a%2015%20min%20call%0A";

export const YOUTUBE_CHANNEL = "https://www.youtube.com/@LifeinHDwithNatalia";

export const SOCIALS = [
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/352676291261569" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/natalialifeinHD" },
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@NataliaAdhd" },
  { id: "x", label: "X", url: "https://www.x.com/NataliaAdhd" },
  { id: "youtube", label: "YouTube", url: YOUTUBE_CHANNEL },
];

export const CREDENTIALS = [
  {
    id: "icf",
    name: "ICF Member",
    detail: "International Coaching Federation",
    img: "/images/icf-badge.png",
    url: "https://www.credly.com/badges/1e8e9a99-f846-4566-a333-ecab8137cf2c/public_url",
  },
  {
    id: "academy",
    name: "Certified Life Coach",
    detail: "Coaching Academy",
    img: "/images/academy-badge.png",
    url: "https://coachingacademy.net/coaches-directory/user/npena/",
  },
];

export const TESTIMONIAL_META = [
  { id: "lucas", name: "Lucas", date: "2024-07-05", cat: "adhd", avatar: "/images/avatar-lucas.jpg" },
  { id: "daniela", name: "Daniela", date: "2024-04-11", cat: "projects", avatar: "/images/avatar-daniela.jpg" },
  { id: "given-cassia", name: "Given & Cassia", date: "2024-06-10", cat: "wedding", avatar: "/images/avatar-given-cassia.jpg" },
  { id: "rosie", name: "Rosie", date: "2025-12-20", cat: "adhd", avatar: "/images/avatar-rosie.webp" },
];

export const PAIN_IDS = ["time", "initiation", "memory"];

export const formatDate = (iso, lang) => {
  if (!iso || !iso.includes("-")) return iso || "";
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  return new Date(y, m - 1, d).toLocaleDateString(lang === "es" ? "es-ES" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const EPISODES = [
  { id: "ep6", num: 6, videoId: "k9gLD5o3v3A", date: "2025-10-21", featured: true },
  { id: "ep5", num: 5, videoId: "hVLYW6RH0GI", date: "2025-09-15", featured: true },
  { id: "ep4", num: 4, videoId: "l3gZaoKCc_U", date: "2025-08-18", featured: true },
  { id: "ep3", num: 3, videoId: "mIMuRkptMZ8", date: "2025-07-14" },
  { id: "ep2", num: 2, videoId: "fRg_IroSTQ4", date: "2025-07-04" },
  { id: "ep1", num: 1, videoId: "v4WV6EZsLW0", date: "2025-05-19" },
];
